export default __webpack_public_path__ + "static/media/tv-screen.0e9f8991.svg";